export const APP_NAME = 'BOOKNOW.US';
export const PrefixKey = 'reviewnailsupply_';
export const DefaultLocale = process.env.APP_DEFAULT_LOCALE || 'en';
export const LocaleKey = PrefixKey + 'locale';
export const ThemeKey = PrefixKey + 'theme';
export const DefaultApiCLient = 'default';
export const AppAuthTokenKey = PrefixKey + '01';
export const AppAuthRefeshTokenKey = PrefixKey + '02';
export const AppAuthDataKey = PrefixKey + '03';
export const AppAuthTokenExpireKey = PrefixKey + '04';
export const AppAuthTokenCreatedKey = PrefixKey + '05';
export const SelectedStoreIdKey = PrefixKey + 'selected_store_id';
export const StoreTimezoneKey = PrefixKey + 'store_timezone';
export const ExpireCookieDays = 30;
export const autoRefeshTokenDays = 30;
export const SearchParamiter = '_q';
export const KeywordParamiter = '_keyword';
export const SearchMinCharactor = 1;
export const PageActionParamiter = 'crud';
export const PageIdParamiter = 'id';
export const BackendRootPath = undefined;
export const AdminRootPath = 'review';
export const CompanyIdAtt = 'companyId';
export const UserIdAtt = 'userId';
export const ProfileNameAtt = 'userProfileId';
export const CacheDateCheckKey = PrefixKey + '_cache_date_check';
export const SucureDeviceIdAtt = '_device_jid';
export const AppDomain = 'nailsupply.us';
export const FileNamePrefix = 'app_file';
export const LatestSyncActiveStatusKey =
  PrefixKey + 'web_latest_sync_active_status';
export const MaxSelectFiles = 10;
export const LimitFileSizeMB = 50;
export const LimitFileSize = LimitFileSizeMB * 1024 * 1024;
export const UserCacheKey = PrefixKey + 'user_cache_info';
// Cờ một lần, sessionStorage: tab đang ở signin vừa reload vì tab khác verify xong email. Chỉ khi
// đó signin mới tự đá đi; user chủ động vào signin thì luôn được thấy form.
export const AuthJustVerifiedKey = PrefixKey + 'auth_just_verified';
// Cờ một lần, sessionStorage: tab vừa đổi mật khẩu rồi nạp lại cứng; màn Profile đọc để toast thành
// công SAU khi nạp (nạp lại xoá toast). Giá trị = Date.now() lúc đánh dấu; quá TTL thì bỏ, để một lần
// vào Profile về sau không ăn nhầm cờ còn sót (vd init sau nạp đưa sang màn khác).
export const AuthPasswordChangedKey = PrefixKey + 'auth_password_changed';
export const PASSWORD_CHANGED_FLAG_TTL_MS = 30_000;
// Đổi giá trị mỗi lần phiên đổi CHỦ. Refresh token không đụng tới, nên tab khác phân biệt được
// "đổi account" với "vừa refresh" mà không phải decode JWT hay đoán claim của BE.
export const SessionIdKey = PrefixKey + 'session_id';
export const ShippingInfoCacheKey = PrefixKey + 'shipping_cache_info';
export const CartInfoCacheKey = PrefixKey + 'cart_cache_info';
export const OrderIdPrefix = '#Order';
export const GuestCartCacheKey = PrefixKey + 'guest_cart_info';
export const ReferralCodeKey = 'ref_code';
export const AffiliateLinkKey = PrefixKey + 'affiliate_link';
export const CacheKey = {
  YEAR_AVAILABLE: PrefixKey + 'year_available',
  LOGIN_LOG: PrefixKey + 'login_log',
};

export const ImageDefault = 'https://api.nailjob.us/uploads/images/7cc8695d-046e-4db1-bc33-4ed4a9f2a17d.webp';
export const Logo = 'https://storage.googleapis.com/nailjob/uploads/68304a8bc609f2d7544507c7/398b7d8d-df68-4332-b48e-9bb3eeaadd68.webp';

export const AffiliateBaseUrl = import.meta.env.VITE_AFFILIATE_BASE_URL || 'http://localhost:9000';

// #795: chỉ khôi phục route /store/add-store. Item "+ Add store" nằm trong dropdown
// store-switcher nên muốn nó hiện lại phải bật cả ENABLE_STORE_SWITCHER.
export const ENABLE_ADD_STORE: boolean = false;

/**
 * Gói trả phí — TẮT cho tới mốc thu phí 01/01/2027 (roadmap
 * `2026-Q3-go-to-market-free-to-paid` cam kết C2).
 *
 * OFF thì: `/pricing` do screen `pages/pricing-free` phục vụ (một card Free), còn screen
 * `pages/pricing` (3 gói) và `pages/billing-detail` KHÔNG được đăng ký route.
 * Cả hai screen đó giữ nguyên code, không xoá — bật cờ này là chúng sống lại.
 *
 * ⚠️ Lý do phải tắt chứ không chỉ bỏ link: bảng giá 3 gói quảng cáo Marketing Automation ·
 * Multi-Branch · Online Booking · Advanced Commission Report trong khi backend không có
 * module nào, và "SMS & Email Settings" thì chỉ đúng nửa Email — để route sống là vẫn vào
 * được bằng URL. (Email giao dịch CÓ thật: nodemailer + 9 template + POST
 * /billings/:id/send-email. SMS mới là thứ không tồn tại — grep twilio/sendgrid/vonage/nexmo
 * toàn backend ra 0.)
 */
export const ENABLE_PAID_PLANS: boolean = false;

// #795: bật lại phải bỏ comment fetchStores() trong layouts/main.vue, nếu không list sẽ rỗng.
export const ENABLE_STORE_SWITCHER: boolean = false;
